// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Loading from './components/Loading';
import SpinButton from './components/SpinButton';
import VueJsonp from 'vue-jsonp';
import Numeral from 'numeral';
import VueI18n from 'vue-i18n';
import messages from './lang';
import AppView from './App.vue';
import VueRouter from 'vue-router';
import routes from './router';
import AuthService from '@/services/AuthService';
import Cors from 'cors';
import AccountSummary from './components/AccountSummary';
import TotalBalance from './components/TotalBalance';
import DatePicker from 'vue2-datepicker';
import EventBus from '@/event-bus';
import moment from 'moment';
import LangService from '@/services/LangService';
import VueFriendlyIframe from 'vue-friendly-iframe';
import VueMask from 'di-vue-mask';
import Carousel from 'vue-owl-carousel';
import AppFooter from '@/components/AppFooter';
import AccountService from '@/services/AccountService';

Vue.component('app-footer', AppFooter);
Vue.component('account-summary', AccountSummary);
Vue.component('carousel', Carousel);
Vue.component('total-balance', TotalBalance);
Vue.component('loading', Loading);
Vue.component('spin-button', SpinButton);
Vue.component('date-picker', DatePicker);
Vue.component('vue-friendly-iframe', VueFriendlyIframe);

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(Cors);
Vue.use(VueJsonp);
Vue.use(Vuelidate);
Vue.use(VueMask);

let accountSrv = new AccountService();

EventBus.$on('switchMt4Account', mt4 => {
  let user = AuthService.getUser();
  user.defaultMT4Account = mt4;
  AuthService.setUser(user);
});

EventBus.$on('onSetDefaultMt4Account', (account) => {
  accountSrv.setDefaultMt4Account(account).then(r => {
    EventBus.$emit('onUpdateComponent', account);
  });
  EventBus.$emit('onUpdateDefaultMt4Account', account);
});

const i18n = new VueI18n({
  locale: LangService.getLang(), // set locale
  fallbackLocale: LangService.getLang(),
  messages
});

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach((to, from, next) => {
  const lang = LangService.getLang();
  i18n.locale = lang;
  next();
});

Vue.mixin({
  data() {
    return {
      currentLanguage: i18n.locale,
      user: {}
    };
  }
});

Vue.filter('formatNumber', function (value) {
  if (typeof value !== "number") {
    return value;
  }

  return Numeral(value).format("0.00");
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY hh:mm:ss');
  }
});

let mv = new Vue({
  i18n,
  el: '#root',
  router: router,
  render: h => h(AppView),
  components: {
    AccountSummary
  }
});



// WEBPACK FOOTER //
// ./src/app.js